/**
 * GeneralTabProductPortfolioCard Component
 *
 * Renders the Product Portfolio card for the General tab, displaying:
 * - Card title "Product portfolio"
 * - Loading state during supplementary data loading or error
 * - Product portfolio value or empty state
 *
 * CALCULATION OWNERSHIP: This component receives all data from parent.
 * Empty value formatting is done within this component.
 */

import GeneralLoader from '../../../loaders/GeneralLoader';
import { PUNCTUATION } from '../../../../utils/constants/notation';
import { FIELD_SOURCE, dataSourceClass } from '../../../../utils/constants/dataSources';

/**
 * @param {Object} props
 * @param {string} props.productPortfolio - Product portfolio description
 * @param {boolean} props.isLoadingSupplementaryData - Whether supplementary data is loading
 * @param {Error|null} props.loadSupplementaryDataError - Error from loading supplementary data
 */
const GeneralTabProductPortfolioCard = ({
  productPortfolio = '',
  isLoadingSupplementaryData = false,
  loadSupplementaryDataError = null
}) => {
  const showLoader = isLoadingSupplementaryData || loadSupplementaryDataError;

  return (
    <div className="card">
      <div className={`title ${dataSourceClass(FIELD_SOURCE.productPortfolio)}`}>
        Product portfolio
      </div>
      {showLoader ? (
        <GeneralLoader />
      ) : (
        <div className="product-portfolio-value">{productPortfolio || PUNCTUATION.EMPTY_VALUE}</div>
      )}
    </div>
  );
};

export default GeneralTabProductPortfolioCard;
